import styled from "styled-components";

export const CommentItem = styled.div`
  &.comments {
    padding-top: 17px;

    & .more {
      width: 44px;
      height: 44px;
      margin-right: -10px;

      cursor: pointer;
    }

    & .recommentsMore {
      padding-top: 14px;
      padding-bottom: 14px;
      padding-left: 16px;
      background-color: #fdfcfb;

      font-size: 14px;
      line-height: 20px;

      cursor: pointer;
    }
  }
`;

export const Deleted = styled.div`
  & .recommentsMore {
    padding-top: 14px;
    padding-bottom: 14px;
    padding-left: 16px;
    background-color: #fdfcfb;

    font-size: 14px;
    line-height: 20px;

    cursor: pointer;
  }
`;

export const DeleteItem = styled.div`
  display: flex;
  padding-left: 1.5px;

  & div {
    font-size: 14px;
    line-height: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;
